import { createContext, useContext } from 'react'
import type { SendMessageOptions } from 'tripPlanner/components/AddToTrip/useAddHotelToTrip'
import type { UseChatCoreReturn } from 'tripPlanner/assistant/runtime/chatStream'

export interface ChatActionsValue {
  submitMessage: UseChatCoreReturn['submitMessage']
  sendMessage: (message: string, options?: SendMessageOptions) => Promise<void>
  sendPostAuthMessage: (signal?: AbortSignal) => Promise<void>
  regenerateResponse: () => Promise<void>
  stopStreaming: () => Promise<boolean>
  resetConversation: (options?: { followTail?: boolean }) => void
  resetStreamingState: () => void
  setFollowTail: React.Dispatch<React.SetStateAction<boolean>>
  retryLastMessage: () => Promise<void>
}

export const ChatActionsContext = createContext<ChatActionsValue | undefined>(undefined)

export function useChatActions(): ChatActionsValue {
  const ctx = useContext(ChatActionsContext)
  if (!ctx) throw new Error('useChatActions must be used within TripPlannerChatProvider')
  return ctx
}
